import { EventCallToAction, EventContentStatus } from 'globalTypes'

import { useMutation } from '@apollo/client'

import styles from './index.module.css'
import MUTATION from './remove-registration.graphql'

interface Props {
  content: EventCallToAction
}

const RemoveRegistration = ({ content }: Props) => {
  const [mutate] = useMutation(MUTATION)

  if (
    !content.isCurrentUserRegistered &&
    (content.status === EventContentStatus.expired ||
      content.status === EventContentStatus.past)
  ) {
    return null
  }

  const onClick = () =>
    mutate({
      variables: {
        id: content.id,
      },
    })

  return (
    <button className={styles.button} onClick={onClick}>
      Annulla registrazione
    </button>
  )
}

export default RemoveRegistration
